import { render, staticRenderFns } from "./r-worker-kind-page.vue?vue&type=template&id=ba20060a"
import script from "./r-worker-kind-page.vue?vue&type=script&lang=js"
export * from "./r-worker-kind-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba20060a')) {
      api.createRecord('ba20060a', component.options)
    } else {
      api.reload('ba20060a', component.options)
    }
    module.hot.accept("./r-worker-kind-page.vue?vue&type=template&id=ba20060a", function () {
      api.rerender('ba20060a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/worker-kind/r-worker-kind-page.vue"
export default component.exports